/**
 * Static mock triage items for local preview.
 *
 * Used by triageService when the triage API isn't reachable (e.g. `npm start`
 * before the triage backend is deployed), so the triage section renders and can
 * be exercised locally. Each entry mirrors a real carrier feed and exercises a
 * different state: a clean CREATE, an UPDATE with a single matched event, a
 * prefix-resolved Alaska tail, and a not-in-fleet warning.
 */
import { TriageItem } from '../services/triageService';

const nowIso = new Date().toISOString();

export const MOCK_TRIAGE: TriageItem[] = [
  {
    triage_id: 'mock-1',
    status: 'PENDING_REVIEW',
    sourceProfileId: '21air-soc',
    sourceEmail: 'soc@21air.us',
    senderVerified: true,
    targetRecordType: 'Unscheduled',
    suggestedAction: 'CREATE',
    tailNumber: 'N661AZ',
    tailInFleet: true,
    carrier: 'ATN',
    aircraftType: 'B763',
    subject: '21Air Fleet Status - AMAZON - N661AZ - MIA',
    receivedAt: nowIso,
    parseStatus: 'OK',
    parseWarnings: [],
    matchedEventId: null,
    matchCandidates: [],
    note: 'RH MLG REPACK UPDATE, A/C ON JACKS, R MLG STRUT REMOVED, REPLACING PACKINGS',
    nextAdviseDate: '2026-06-24',
    nextAdviseTimeZulu: '03:30',
    ertsDate: '',
    ertsTimeZulu: '',
    createdAt: nowIso,
    updatedAt: nowIso,
    version: 0,
  },
  {
    triage_id: 'mock-2',
    status: 'PENDING_REVIEW',
    sourceProfileId: 'atn-deferred',
    sourceEmail: 'ofsmail@airtransport.cc',
    senderVerified: true,
    targetRecordType: 'Deferred',
    suggestedAction: 'UPDATE',
    tailNumber: 'N347AZ',
    tailInFleet: true,
    carrier: 'ATN',
    aircraftType: 'B763',
    subject: '347AZ Restriction Added',
    receivedAt: nowIso,
    parseStatus: 'OK',
    parseWarnings: [],
    matchedEventId: 'EVT-DEFERRED-347',
    matchCandidates: [
      {
        eventId: 'EVT-DEFERRED-347',
        recordType: 'Deferred',
        status: 'IN_WORK',
        discrepancy: 'APU bleed inoperative — deferred per MEL 49-11',
        station: 'CVG',
      },
    ],
    note: 'Autothrottle Servo "Notify OPS Control"',
    deferred: {
      timeDeclaredZulu: '2026-06-20T16:00:00Z',
      dueDateZulu: '2026-06-30T23:59:00Z',
      deferralReference: 'ATI-22-30-01-02',
      catType: 'C',
      trk: false,
      apuDeferral: false,
      etopsRestricted: false,
      catIiiRestricted: true,
      operationallyRestrictive: false,
    },
    createdAt: nowIso,
    updatedAt: nowIso,
    version: 0,
  },
  {
    triage_id: 'mock-3',
    status: 'PENDING_REVIEW',
    sourceProfileId: 'alaska-smartsheet',
    sourceEmail: 'automation@app.smartsheet.com',
    senderVerified: true,
    targetRecordType: 'Unscheduled',
    suggestedAction: 'CREATE',
    tailNumber: 'N5897K',
    tailInFleet: true,
    carrier: 'ASA',
    aircraftType: 'A330',
    subject: 'MOC / N5897 / FLT 2618 / CVG / UNSCH. MX',
    receivedAt: nowIso,
    parseStatus: 'OK',
    parseWarnings: ['Tail resolved by prefix to N5897K'],
    matchedEventId: null,
    matchCandidates: [],
    discrepancy: 'NLG SWIVAL VLV LEAKING',
    note: 'ETR DATE: 06/13/26\nPENDING: ETR PARTS PLUS 4 HRS\nCOMPLETED: CVG TO REQ PART',
    nextAdviseDate: '',
    nextAdviseTimeZulu: '08:00',
    ertsDate: '',
    ertsTimeZulu: '',
    createdAt: nowIso,
    updatedAt: nowIso,
    version: 0,
  },
  {
    triage_id: 'mock-5',
    status: 'PENDING_REVIEW',
    sourceProfileId: 'alaska-smartsheet',
    sourceEmail: 'automation@app.smartsheet.com',
    senderVerified: true,
    targetRecordType: 'Unscheduled',
    suggestedAction: 'CREATE',
    tailNumber: 'N5881K',
    tailInFleet: true,
    carrier: 'ASA',
    aircraftType: 'A330',
    subject: 'MOC / N5881 / AFW / IN SERVICE',
    receivedAt: nowIso,
    parseStatus: 'OK',
    parseWarnings: ['Tail resolved by prefix to N5881K'],
    matchedEventId: null,
    matchCandidates: [],
    discrepancy: '',
    note: "COMPLETED: SWAPPED ADIRU'S AND DEFERRED #2; RELEASED INTO SERVICE: 0700Z",
    nextAdviseDate: '',
    nextAdviseTimeZulu: '',
    ertsDate: '',
    ertsTimeZulu: '07:00',
    createdAt: nowIso,
    updatedAt: nowIso,
    version: 0,
  },
  {
    triage_id: 'mock-4',
    status: 'PENDING_REVIEW',
    sourceProfileId: 'atsg-unscheduled',
    sourceEmail: 'reporting-admin@atsginc.com',
    senderVerified: true,
    targetRecordType: 'Unscheduled',
    suggestedAction: 'CREATE',
    tailNumber: 'N571AZ',
    tailInFleet: true,
    carrier: 'ATN',
    aircraftType: 'B763',
    subject: '571AZ Updated.',
    receivedAt: nowIso,
    parseStatus: 'OK',
    parseWarnings: [],
    matchedEventId: null,
    matchCandidates: [],
    discrepancy: '',
    note: 'Ops check of RH TR good. Awaiting log page/ - VC',
    noteDate: '2026-06-24',
    noteTime: '13:23',
    nextAdviseDate: '2026-06-24',
    nextAdviseTimeZulu: '14:00',
    ertsDate: '2026-06-24',
    ertsTimeZulu: '19:00',
    createdAt: nowIso,
    updatedAt: nowIso,
    version: 0,
  },
];
